module.exports = __webpack_public_path__ + "img/face1.e727e529.png";